// Wipes everything this app keeps in the browser, then reloads the login page.
// Not clearable from JS: cookies set httpOnly, and the HTTP cache (refreshed below for the login URL only).
export async function resetAndSignOut() {
  const loginUrl = '/auth/login';
  localStorage.clear();
  sessionStorage.clear();
  await Promise.allSettled([
    typeof caches !== 'undefined'
      ? caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      : undefined,
    navigator.serviceWorker?.getRegistrations().then((items) => Promise.all(items.map((item) => item.unregister()))),
    indexedDB.databases?.().then((dbs) => Promise.all(dbs.map((db) => db.name && indexedDB.deleteDatabase(db.name)))),
    // Replace any long-cached copy of the login page so the reload fetches the latest app version.
    fetch(loginUrl, { cache: 'reload' }),
  ]);
  // A full navigation (not router navigate) also drops the in-memory query cache and stores.
  window.location.replace(loginUrl);
}
